import { render, staticRenderFns } from "./notiForms.vue?vue&type=template&id=a21eb320&scoped=true"
import script from "./notiForms.vue?vue&type=script&lang=js"
export * from "./notiForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21eb320",
  null
  
)

export default component.exports